import React from 'react';
import { Components } from 'react-markdown';

export const markdownComponents: Components = {
  p: ({ children }) => <p className='mb-2 last:mb-0'>{children}</p>,
  ul: ({ children }) => (
    <ul className='list-disc ml-4 mb-2'>{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className='list-decimal ml-4 mb-2'>{children}</ol>
  ),
  li: ({ children }) => <li className='mb-1'>{children}</li>,
  code: ({ className, children }) => {
    const isInline = !className;
    return isInline ? (
      <code className='bg-gray-100 dark:bg-gray-700 px-1 py-0.5 rounded text-sm'>
        {children}
      </code>
    ) : (
      <code
        className={`${className} block bg-gray-100 dark:bg-gray-700 p-2 rounded text-sm overflow-x-auto`}
      >
        {children}
      </code>
    );
  },
  pre: ({ children }) => <pre className='mb-2'>{children}</pre>,
  strong: ({ children }) => (
    <strong className='font-semibold'>{children}</strong>
  ),
  em: ({ children }) => <em className='italic'>{children}</em>,
  h1: ({ children }) => (
    <h1 className='text-xl font-bold mb-2'>{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className='text-lg font-bold mb-2'>{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 className='text-base font-bold mb-1'>{children}</h3>
  ),
  blockquote: ({ children }) => (
    <blockquote className='border-l-4 border-gray-300 dark:border-gray-600 pl-3 italic mb-2'>
      {children}
    </blockquote>
  ),
  a: ({ href, children }) => (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className='text-blue-600 dark:text-blue-400 hover:underline'
    >
      {children}
    </a>
  ),
};
